import { render, staticRenderFns } from "./Load.vue?vue&type=template&id=2c83a132&lang=pug"
import script from "./Load.vue?vue&type=script&lang=js"
export * from "./Load.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports